module.exports = __webpack_public_path__ + "img/money21.776fde58.png";